// Did a shell command in this turn try to PRODUCE a file? The answer arms the
// «<name> не найден по указанному пути» card (message-part.tsx): a file the
// answer names, missing on disk, after a turn that was building something.
//
// The first version looked for a script extension or a redirect anywhere in
// the command, so a command that only LOOKED at a file counted as building it.
// Asked «файл main.py есть?», the model ran `Get-Item "…\app\main.py"` (found
// it, 2194 bytes), answered «Да, main.py есть» — and the chat hung a warning
// under that true answer claiming the file was never created (tester report
// 2026-09-25, Windows; «чат почти на все файлы жалуется»). `2>$null`, which
// PowerShell commands carry to hush an error, counted as a redirect too.
//
// So a command is judged per segment (`;`, `&&`, `||`, `|`, newline): a
// segment that starts with a read-only command does not count — unless it
// redirects into a file, which is a write whatever came first — and
// redirects that only discard (`2>$null`, `>/dev/null`, `2>&1`, `| Out-Null`)
// are no writes at all.

const PRODUCING =
  /multitool-node|\bnode\b|\bpython3?\b|\.(?:js|cjs|mjs|py)\b|\b(?:cp|mv|tee|touch|convert|soffice|libreoffice)\b/

// Commands that read or list and never write. An optional `$x = ` assignment,
// `(`, or call operator `&` in front still reads.
const READ_ONLY =
  /^\s*(?:\$[\w:]+\s*=\s*)?\(?\s*(?:&\s*)?(?:Get-Item|Get-ChildItem|Get-Content|Get-FileHash|Get-ItemProperty|Test-Path|Resolve-Path|Select-String|Measure-Object|ls|dir|cat|type|head|tail|stat|file|wc|find|findstr|grep|rg|where|which|tree|du)(?![\w-])/i

// Redirects that throw output away rather than keep it.
const DISCARDING = /\d?>&\d|\d?>>?\s*(?:\$null|\/dev\/null|nul)(?![\w.])|\|\s*Out-Null\b/gi

const WRITES_A_FILE = />>?\s*[^\s&>]/

export function commandProducesFiles(command: string): boolean {
  const kept = command.replace(DISCARDING, " ")
  return kept.split(/;|&&|\|\||\||\n/).some((segment) => {
    if (WRITES_A_FILE.test(segment)) return true
    if (READ_ONLY.test(segment)) return false
    return PRODUCING.test(segment)
  })
}
